// extracted by mini-css-extract-plugin
export default {"list":"Horoscope_list__Vo2Hf"};